/**
 * @author Nihar <nihar.baishya@314ecorp.com>
 * @description React Hook useDeletePracticeLocation
 */

import { useMutation, useQueryClient, UseMutationResult } from '@tanstack/react-query';

import api from 'client/index';
import AppEvents from '@veritable/common/utils/appEvents';
import { invalidateMetadata } from 'app-constants/queryKeys';

/**
 * Mutate for Delete Location
 *
 */
const useDeleteLocation = (): UseMutationResult<unknown, IAxiosError, { id: string }, unknown> => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async ({ id }) => {
			await api.ServiceLocationDetailsApi.deleteServiceLocationDetails({ serviceLocationId: id });
		},
		onSuccess: () => {
			AppEvents.publishApiSuccess();
			invalidateMetadata(queryClient);
		},
		onError: (error) => {
			AppEvents.publishApiError({ error });
		},
	});
};

export default useDeleteLocation;
